/**
 * PURPOSE: Centralizar las llamadas HTTP de la llave eliminatoria del evento 17.
 * RESPONSIBILITIES: Consultar, previsualizar, generar y actualizar clasificados.
 * COLLABORATORS: Bracket2.jsx y endpoints /event17bracket/*.
 * ROUTE: frontend/src/services/event17Bracket.js
 */

import axios from "axios";
import API_BASE_URL from "../config/config.js";

export async function getEvent17Bracket({ idevent, idsport }) {
  const { data } = await axios.post(`${API_BASE_URL}/event17bracket/get`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
  });

  return data;
}

export async function previewEvent17Bracket({ idevent, idsport }) {
  const { data } = await axios.post(`${API_BASE_URL}/event17bracket/preview`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
  });

  return data;
}

export async function generateEvent17Bracket({
  idevent,
  idsport,
  seedOrder,
  replaceExisting = false,
}) {
  const { data } = await axios.post(`${API_BASE_URL}/event17bracket/generate`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
    seedOrder: Array.isArray(seedOrder) ? seedOrder.map(Number) : [],
    replaceExisting: Boolean(replaceExisting),
  });

  return data;
}

export async function advanceEvent17Bracket({ idevent, idsport }) {
  const { data } = await axios.patch(`${API_BASE_URL}/event17bracket/advance`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
  });

  return data;
}
